// import Player from "xgplayer";
import Draggabilly from "draggabilly";
let yuanmoMini = function () {
  let player = this;
  let root = player.root;

  function onYMMiniBtnClick() {
    if (hasClass(root, "xgplayer-miniplayer-active")) {
      player.exitMiniplayer();
    } else {
      player.getMiniplayer();
    }
  }
  player.on("ymMiniBtnClick", onYMMiniBtnClick);
  function onDestroy() {
    player.off("ymMiniBtnClick", onYMMiniBtnClick);
    player.off("destroy", onDestroy);
  }
  player.once("destroy", onDestroy);
  player.openYMMini = function () {
    if (hasClass(root, "xgplayer-is-fullscreen")) {
      this.exitFullscreen(root);
    }
    if (hasClass(root, "xgplayer-is-cssfullscreen")) {
      this.exitCssFullscreen();
    }
    if (hasClass(root, "xgplayer-rotate-fullscreen")) {
      this.exitRotateFullscreen();
    }
    let ymLay = createDom(
      "xg-miniplayer-lay",
      "<div></div>",
      {},
      "xgplayer-miniplayer-lay"
    );
    this.root.appendChild(ymLay);
    // let width = this.config?.miniplayerConfig?.width ?? "320px";
    // let height = this.config?.miniplayerConfig?.width ?? "180px";
    // style="width:${width};height:${height}"
    let dragHandle = createDom(
      "xg-miniplayer-drag",
      `<div class="drag-handle" ${
        this.config?.miniplayerConfig?.miniDrag
          ? ""
          : 'style="width:160px;height:90px"'
      }>
      ${
        this.config?.miniplayerConfig?.miniDrag
          ? "<div style='display:flex;justify-content: flex-end;'><img style='width:18px;height:18px;' src='https://ntppc.oss-cn-shanghai.aliyuncs.com/mp4/20240410hwhjs5ni.png'></div>"
          : ""
      }
      </div>`,
      { tabindex: 9 },
      "xgplayer-miniplayer-drag"
    );
    this.root.appendChild(dragHandle);
    // eslint-disable-next-line no-unused-vars
    let draggie = new Draggabilly(".xgplayer", {
      handle: ".drag-handle",
      containment: ".intelligence-wrapper",
    });
    addClass(this.root, "xgplayer-miniplayer-active");
    this.root.style.right = this.config?.miniplayerConfig?.right ?? 0;
    this.root.style.bottom = this.config?.miniplayerConfig?.bottom ?? "200px";
    this.root.style.width = this.config?.miniplayerConfig?.width ?? "320px";
    this.root.style.height = this.config?.miniplayerConfig?.height ?? "180px";
    if (this.config.fluid) {
      this.root.style["padding-top"] = "";
    }
    let player = this;
    ["click", "touchend"].forEach((item) => {
      ymLay.addEventListener(item, function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (hasClass(root, "xgplayer-is-replay")) {
          // 重播优先级更高
          player.replay();
          return;
        }
        if (hasClass(root, "xgplayer-ended")) {
          player.replay();
          return;
        }
        if (hasClass(root, "xgplayer-pause")) {
          player.play();
          return;
        }
        player.pause();
        // if (hasClass(root, "xgplayer-is-fullscreen")) {
        //   //有全屏就关闭，没有就打开全屏
        //   player.exitFullscreen(root);
        // } else {
        //   player.getFullscreen(root);
        // }
        // if (player.config?.miniplayerConfig?.miniDrag) {
        //   window.scrollTo({
        //     top: 0,
        //     behavior: "smooth", // 平滑滚动
        //   });
        // }
        // player.exitMiniplayer()
        // player.root.style.top = `${Top}px`
        // player.root.style.left = `${Left}px`
      });
    });
  };
  player.closeYMMini = function () {
    removeClass(this.root, "xgplayer-miniplayer-active");
    this.root.style.right = "";
    this.root.style.bottom = "";
    this.root.style.top = "";
    this.root.style.left = "";
    if (this.config.fluid) {
      this.root.style["width"] = "100%";
      this.root.style["height"] = "0";
      this.root.style["padding-top"] = `${
        (this.config.height * 100) / this.config.width
      }%`;
    } else {
      if (this.config.width) {
        if (typeof this.config.width !== "number") {
          this.root.style.width = this.config.width;
        } else {
          this.root.style.width = `${this.config.width}px`;
        }
      }
      if (this.config.height) {
        if (typeof this.config.height !== "number") {
          this.root.style.height = this.config.height;
        } else {
          this.root.style.height = `${this.config.height}px`;
        }
      }
    }

    let dragLay = findDom(this.root, ".xgplayer-miniplayer-lay");
    if (dragLay && dragLay.parentNode) {
      dragLay.parentNode.removeChild(dragLay);
    }
    let dragHandle = findDom(this.root, ".xgplayer-miniplayer-drag");
    if (dragHandle && dragHandle.parentNode) {
      dragHandle.parentNode.removeChild(dragHandle);
    }
  };
  function hasClass(el, className) {
    if (!el) {
      return false;
    }

    if (el.classList) {
      return Array.prototype.some.call(
        el.classList,
        (item) => item === className
      );
    } else if (el.className) {
      return !!el.className.match(
        new RegExp("(\\s|^)" + className + "(\\s|$)")
      );
    } else {
      return false;
    }
  }
  function createDom(el = "div", tpl = "", attrs = {}, cname = "") {
    let dom = document.createElement(el);
    dom.className = cname;
    dom.innerHTML = tpl;
    Object.keys(attrs).forEach((item) => {
      let key = item;
      let value = attrs[item];
      if (el === "video" || el === "audio") {
        if (value) {
          dom.setAttribute(key, value);
        }
      } else {
        dom.setAttribute(key, value);
      }
    });
    return dom;
  }
  function addClass(el, className) {
    if (!el) {
      return;
    }

    if (el.classList) {
      className
        .replace(/(^\s+|\s+$)/g, "")
        .split(/\s+/g)
        .forEach((item) => {
          item && el.classList.add(item);
        });
    } else if (!hasClass(el, className)) {
      el.className += " " + className;
    }
  }

  function removeClass(el, className) {
    if (!el) {
      return;
    }

    if (el.classList) {
      className.split(/\s+/g).forEach((item) => {
        el.classList.remove(item);
      });
    } else if (hasClass(el, className)) {
      className.split(/\s+/g).forEach((item) => {
        let reg = new RegExp("(\\s|^)" + item + "(\\s|$)");
        el.className = el.className.replace(reg, " ");
      });
    }
  }
  function findDom(el = document, sel) {
    let dom;
    // fix querySelector IDs that start with a digit
    // https://stackoverflow.com/questions/37270787/uncaught-syntaxerror-failed-to-execute-queryselector-on-document
    try {
      dom = el.querySelector(sel);
    } catch (e) {
      if (sel.indexOf("#") === 0) {
        dom = el.getElementById(sel.slice(1));
      }
    }
    return dom;
  }
};
// Player.install("yuanmoMini", yuanmoMini);
// Player.use("yuanmoMini");
export default yuanmoMini;
